export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10075.9a73a576.jpg";